import emotionCreateCache from '@emotion/cache';
import { emotionCacheKey } from "utils/Constants.js";

const emotionCache = emotionCreateCache({
	key: emotionCacheKey,
	nonce: window.__CSP_NONCE,
});
export default emotionCache;
